import { type StrapiMedia } from '~/utils/strapiImageGetters'

export type StrapiSeo = {
  metaTitle: string
  metaDescription: string
  metaImage: StrapiMedia
  metaSocial: any[]
  keywords: string
  metaRobots: string
  metaViewport: string
  canonicalURL: string
}
export type StrapiEventListPage = {
  id: number
  attributes: {
    title: string
    description: string
    slug: string
    type: string
    createdAt: string
    updatedAt: string
    publishedAt: string
    locale: string
    horizontalCardListTitle: null
    horizontalCardListLink: null
    horizontalCardListLinkText: null
    citySlug: string | null
    searchFilters: {
      tags: { label: string; value: string }[]
    }
    categorySlug: string | null
    featured: boolean
    searchHeading: string
    searchSubtitle: string | null
    localizations: StrapiEventListPage
    showcase: any
    seo: StrapiSeo
  }
}

export enum EventListPageType {
  CITY = 'city',
  CATEGORY = 'category',
  CITY_CATEGORY = 'city-category',
  GENERAL = 'general',
  TEAMEVENT = 'teamevent',
  SEARCH = 'search',
}

export type EventListPageTypeString =
  | 'city'
  | 'category'
  | 'city-category'
  | 'general'
  | 'teamevent'
